export enum Experiments {
  RefreshWidgetsOnSettingsChange = 'specs.membersArea.RefreshWidgetsOnSettingsChange',
  UrlMembersArea = 'specs.membersArea.urlMembersArea',
  ProfileCardNewLayouts = 'specs.profileCardOOI.newLayouts',
  MemberBlockMember = 'specs.membersArea.MemberBlockMember',
  LoginInPopup = 'specs.membersArea.LoginInPopup',
  MyAccountUploadAvatar = 'specs.myAccount.UploadAvatar',
}
